module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABCUlEQVRYhe2XYQ6DIAxGi/FecjPam5WTffszCdYxEDQuiy9Z4ib6PbRFR/RwMw7A8ElEpOskIQRHAIY+zAwAUFW0oqpgZhARpuHpd+C9T9u3CKjqvQI5j8B/CcQYD4+ZzxRolbhUYCVvtZx8DdgJ9C6pn8KZmVQ1iazfl2XZXKUkICKwdq1hI0wj4d9YZ1xjFhGEELqDVJVEZBdeGmul0i04Wr0r3vtdYZWwYgDcKV1gZ7W8hWL2ez6GmQmAI/qBlbDpCtSKyd6CeKAzNgKloFJR1fa31MZGoNQNNYHScS2FvREoHVB7ce3toJ3AFQGWvAOSgF1IrsKGE73/FzjnTnkI1bDhDw9ERC/gZOl19wIRxAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/ADRIVE_32.png
// module id = 42
// module chunks = 0